export class DeviceUtils {
  static isPokerApp = () =>
    typeof window.external?.onSiteLoaded !== "undefined" ||
    !!window.pokerNativeInterface;
}
